import { render, staticRenderFns } from "./BigMap.vue?vue&type=template&id=709c7ab6&scoped=true"
import script from "./BigMap.vue?vue&type=script&lang=js"
export * from "./BigMap.vue?vue&type=script&lang=js"
import style0 from "./BigMap.vue?vue&type=style&index=0&id=709c7ab6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709c7ab6",
  null
  
)

export default component.exports